import { Link } from "react-router-dom";
import { ArrowUpRight, Waves, Drum, Timer, Mic } from "lucide-react";

const TOOLS = [
  {
    title: "Tanpura",
    desc: "Continuous drone for daily riyaaz.",
    icon: Waves,
    to: "/tanpura",
  },
  {
    title: "Tabla",
    desc: "Practice popular Hindustani taals.",
    icon: Drum,
    to: "/taals",
  },
  {
    title: "Metronome",
    desc: "Improve timing and rhythm.",
    icon: Timer,
    to: "/metronome",
  },
  {
    title: "Flute Tuner",
    desc: "Tune your bansuri accurately.",
    icon: Mic,
    to: "/tuner",
  },
];

export default function Landing() {
  return (
    <div data-testid="landing-page">

      <section className="relative overflow-hidden">

        <div className="absolute inset-0 schematic opacity-20 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

          <div className="grid lg:grid-cols-2 gap-20 items-center">
		  
		  
		  {/* LEFT SIDE */}

<div>

    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-muted-foreground mb-6">
        <span className="w-10 h-px bg-primary"></span>
        KUNDAN FLUTES
    </div>

    <h1 className="font-sans font-extrabold text-5xl md:text-6xl xl:text-7xl leading-tight">
        Daily Riyaaz.
        <br />
        <span className="text-primary">
            Timeless Music.
        </span>
    </h1>

    <p className="mt-8 text-lg text-muted-foreground leading-8 max-w-xl">
        Everything a Hindustani musician needs for focused daily practice.
        <br /><br />
        Tanpura • Tabla • Metronome • Bansuri Tuner
        <br /><br />
        No ads. No signup. Just pure riyaaz.
    </p>

    <div className="mt-10 flex flex-wrap gap-4">

        <Link
            to="/tanpura"
            className="inline-flex items-center gap-2 px-7 h-12 rounded-full bg-primary text-primary-foreground font-semibold hover:-translate-y-1 transition-all"
        >
            Start Riyaaz
            <ArrowUpRight size={18} />
        </Link>

        <Link
            to="/tuner"
            className="inline-flex items-center gap-2 px-7 h-12 rounded-full border border-border hover:border-primary transition-all"
        >
            Open Tuner
        </Link>

    </div>

</div>

{/* RIGHT SIDE */}

<div>

    <div className="grid grid-cols-2 gap-6">

        {TOOLS.map((tool) => {

            const Icon = tool.icon;

            return (

                <Link
                    key={tool.title}
                    to={tool.to}
                    className="riyaaz-card rounded-2xl border border-border bg-card p-8 hover:border-primary hover:-translate-y-1 transition-all duration-300"
                >

                    <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6">

                        <Icon
                            size={28}
                            className="text-primary"
                        />

                    </div>

                    <h3 className="text-2xl font-bold mb-3">

                        {tool.title}

                    </h3>

                    <p className="text-muted-foreground leading-7">

                        {tool.desc}

                    </p>

                    <div className="mt-6 flex items-center text-primary font-semibold">

                        Open

                        <ArrowUpRight
                            size={18}
                            className="ml-2"
                        />

                    </div>

                </Link>

            );

        })}

    </div>

</div>

          </div> {/* End Grid */}

        </div> {/* End Container */}

      </section>

      {/* Footer */}



    </div>
  );
}



